<template>
  <v-row v-if="menuItems">
    <v-col
      v-for="category in adjustProductsLengthForBreakpoint(categories)"
      class="d-flex justify-center position-relative"
      :key="category.name"
      cols="12"
      md="6"
      lg="4"
      xl="3"
    >
      <v-card color="white">
        <Menu :name="category.name" :src="category.img" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { slug } from "github-slugger";
import { mapGetters } from "vuex";
import Menu from "@/components/Departments/Menus/Menu.vue";

export default {
  name: "Menus",
  components: { Menu },
  computed: {
    ...mapGetters("menu", { menuItems: "bySection" }),
    categories() {
      return Object.entries(this.menuItems)
        .slice(0, 8)
        .map((item) => ({
          name: item[0],
          img: this.getImageFromMenuProducts(item[1]),
        }));
    },
  },
  methods: {
    adjustProductsLengthForBreakpoint(items) {
      // 4 products are returned form API which fills an xl row (default)
      const end = {
        sm: 2,
        md: 4,
        lg: 6,
        xl: 8,
      };
      return items.slice(0, end[this.$vuetify.breakpoint.name]) || items;
    },
    getImageFromMenuProducts(products) {
      const item = products.find(({ image }) => image !== null);
      return item ? item.image : null;
    },
    slug,
  },
};
</script>
